import { render, staticRenderFns } from "./EditEventSummary.vue?vue&type=template&id=6b34c195&scoped=true"
import script from "./EditEventSummary.vue?vue&type=script&lang=js"
export * from "./EditEventSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b34c195",
  null
  
)

export default component.exports